export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

export const PHYSICS = {
  gravity: 1400,
  playerSpeed: 260,
  jumpVelocity: -560,
  doubleJumpVelocity: -520,
};

export const COLORS = {
  bgDark: 0x0d1117,
  bgMid: 0x161b22,
  accent: 0xf78166,
  text: 0xe6edf3,
  heart: 0xff6b81,
  mona: 0x9c8cff,
  ducky: 0xffd166,
  copilot: 0x6cd0ff,
  corruption: 0xb02a55,
};

export const STARTING_HEARTS = 3;
